module.exports = __webpack_public_path__ + "static/img_4855-4f0790407b9e5c1745c21085afadaeea.webp";